class BookingSection extends HTMLElement {
  #currentStep = 1;
  #selectedOnlineUrl = '';
  #selectedOfflineUrl = '';
  #offlineOnly = false;
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;
    this.addEventListener('click', this.#handleClick, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    const categoryBtn = /** @type {HTMLElement | null} */ (/** @type {Element} */ (event.target).closest('.booking-section__category'));
    if (categoryBtn) {
      this.#selectedOnlineUrl = categoryBtn.dataset.onlineUrl ?? '';
      this.#selectedOfflineUrl = categoryBtn.dataset.offlineUrl ?? '';
      this.#offlineOnly = categoryBtn.hasAttribute('data-offline-only');
      this.#updateTypeButtons();
      this.#showStep(2);
      return;
    }

    const typeBtn = /** @type {HTMLElement | null} */ (/** @type {Element} */ (event.target).closest('[data-appointment-type]'));
    if (typeBtn) {
      const type = typeBtn.dataset.appointmentType;
      const iframe = /** @type {HTMLIFrameElement | null} */ (this.querySelector('.booking-section__widget-iframe'));
      if (iframe) {
        iframe.src = type === 'online' ? this.#selectedOnlineUrl : this.#selectedOfflineUrl;
      }
      this.#showStep(3);
      return;
    }

    const backBtn = /** @type {Element} */ (event.target).closest('.booking-section__back-btn');
    if (backBtn) {
      if (this.#currentStep === 3) {
        const iframe = /** @type {HTMLIFrameElement | null} */ (this.querySelector('.booking-section__widget-iframe'));
        if (iframe) iframe.src = '';
      }
      this.#showStep(this.#currentStep - 1);
    }
  };

  #updateTypeButtons() {
    const onlineBtn = /** @type {HTMLElement | null} */ (this.querySelector('[data-appointment-type="online"]'));
    const typeGrid = /** @type {HTMLElement | null} */ (this.querySelector('.booking-section__type-grid'));

    if (onlineBtn) {
      onlineBtn.classList.toggle('mobile:hidden', this.#offlineOnly);
      onlineBtn.classList.toggle('desktop:hidden', this.#offlineOnly);
    }

    if (typeGrid) {
      typeGrid.classList.toggle('booking-section__grid--two-items', !this.#offlineOnly && !!onlineBtn);
      typeGrid.classList.toggle('booking-section__grid--one-item', this.#offlineOnly || !onlineBtn);
    }
  }

  /** @param {number} step */
  #showStep(step) {
    this.#currentStep = step;
    this.dataset.currentStep = String(step);

    this.querySelectorAll('.booking-section__step').forEach((s) => {
      /** @type {HTMLElement} */ (s).hidden = parseInt(/** @type {HTMLElement} */ (s).dataset.step ?? '', 10) !== step;
    });
  }
}

if (!customElements.get('booking-section')) {
  customElements.define('booking-section', BookingSection);
}
